import React, { Component } from 'react';
import { Link } from 'react-router-dom';
//import './App.css';
import firebase from './../Firestore'
import config from 'react-global-configuration';
import CategoriaNombre from './CategoriaNombre'
import NavBar from './NavBar'
//import Precio from './Precio'
//import Imagen from './Imagen'

class AdicionalLista extends Component {
  constructor(props) {
    super(props);
    this.ref = firebase.firestore().collection('adicionales').orderBy("categoriaID");
    this.unsubscribe = null;

    this.state = {
      adicionales: []
    };
  }

  onCollectionUpdate = (querySnapshot) => {
    const adicionales = [];
    querySnapshot.forEach((doc) => {
      const { nombre, categoriaID, precio, enStock } = doc.data();
      adicionales.push({
        key: doc.id,
        doc, // DocumentSnapshot
        nombre,
        categoriaID,
        precio,
        enStock
      });
    });
    this.setState({
      adicionales
   });
  }



  async componentDidMount() {
    this.unsubscribe = await this.ref.onSnapshot(this.onCollectionUpdate);

  }

  render() {
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              LISTA DE ADICIONALES
            </h3>
          </div>
          <div>
            <small>Los adicionales estan asociados a una categoría y se muestran junto a todos los productos de la mísma. Ej: "Extra provolone" es una opción de adicional para todas las pizzas. Los adicionales no se muestran como un producto independiente.</small>
          </div>
          <div className="panel-body">
            <table className="table table-stripe">
              <thead>
                <tr>
                  <th>Adicionales</th>
                </tr>
              </thead>
              <tbody>
                {this.state.adicionales.map((adicional, index, arr) =>

                  <tr key={adicional.key}>
                    <td>

                      <span className="badge badge-secondary float-right"><CategoriaNombre categoriaID={adicional.categoriaID} /></span>
                      <Link className="mr-2" to={`/admin/adicional/show/${adicional.key}`}><strong>{adicional.nombre}</strong></Link>

                      {!adicional.enStock &&
                        <span className="badge badge-danger mr-2"><small>SIN STOCK</small></span>
                      }


                      <span className="text-success h6 mr-2">${adicional.precio}</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default AdicionalLista;
